const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  serviceType: process.env.REACT_APP_SERVICE_TYPE?.toLowerCase() === 'web' ? 'web' : 'mock',
};

export default config;
